export enum DamperType {
    Rectangular,
    Round,
}

export enum DamperBlades {
    ParallelBladeWithSeals,
    OpposedBladeWithSeals,
    ParallelBladeWithoutSeals,
    OpposedBladeWithoutSeals,
}

export enum RoundDamperBlades {
    BladeWithSeals,
    BladeWithoutSeals,
}

export enum AirflowEnum {
    low,
    mid,
    high,
}

export type UserInputAm = {
    air: AirflowEnum;
}

export type UserInputEu = {
    safety: string;
}

export type UserInput = {
    result: string;
    damper: DamperType;
    areaOrDiameter: string;
    width: string;
    height: string;
    diameter: string;
    blade: DamperBlades | null;
    roundDumper: RoundDamperBlades | null;
    force: string | null;
    crankArmLength: string;
} & UserInputEu & UserInputAm;

export const initialState: UserInput = {
    result: '',
    damper: DamperType.Rectangular,
    areaOrDiameter: '',
    width: '',
    height: '',
    diameter: '',
    blade: null,
    roundDumper: null,
    force: null,
    crankArmLength: '',
    safety: '20',
    air: AirflowEnum.low,
};

export type UserInputAction = {
    type: 'reset';
} | {
    type: 'damper';
    payload: DamperType;
} | {
    type: 'blade';
    payload: DamperBlades;
} | {
    type: 'roundBlade';
    payload: RoundDamperBlades;
} | {
    type: 'force';
    payload: string | null;
} | {
    type: keyof Omit<UserInput, 'damper' | 'blade' | 'roundBlade' | 'force'>;
    payload: string;
}
